import { schema } from "normalizr";

const WarehouseSchema = new schema.Entity("warehouses");
const WarehouseArraySchema = new schema.Array(WarehouseSchema);

export { WarehouseSchema, WarehouseArraySchema };